import React from 'react'

const Loading = () => {

  return <>
<div className="three">
<div className="circle"></div>
</div>
  </>
}

export default Loading
